import { createContext, useContext, useState, useCallback, useEffect } from "react";

const LayoutContext = createContext(null);
const COLLAPSE_KEY = "tf_sidebar_collapsed";
const PIN_KEY = "tf_sidebar_pinned";

export function LayoutProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(COLLAPSE_KEY) === "1");
  const [pinned, setPinned] = useState(() => localStorage.getItem(PIN_KEY) !== "0");
  const [panel, setPanel] = useState({ open: false, title: "", content: null });

  useEffect(() => {
    localStorage.setItem(COLLAPSE_KEY, collapsed ? "1" : "0");
  }, [collapsed]);
  useEffect(() => {
    localStorage.setItem(PIN_KEY, pinned ? "1" : "0");
  }, [pinned]);

  const toggleSidebar = useCallback(() => setCollapsed((c) => !c), []);
  const togglePinned = useCallback(() => setPinned((p) => !p), []);
  const openContextPanel = useCallback((title, content) => setPanel({ open: true, title, content }), []);
  const closeContextPanel = useCallback(() => setPanel((p) => ({ ...p, open: false })), []);

  return (
    <LayoutContext.Provider value={{ collapsed, toggleSidebar, pinned, togglePinned, panel, openContextPanel, closeContextPanel }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const ctx = useContext(LayoutContext);
  if (!ctx) throw new Error("useLayout must be used within LayoutProvider");
  return ctx;
}
